/**
 * @description Api URL地址
 */
import {Env} from '../env/'

const isLan = Env.Production

let root
let walletRoot
let otherApiRoot
let comApiRoot
let promotionRoot
let openApiRoot
let seckillApiRoot
let orderApiRoot
let pointRoot
if (isLan === 'dev') {
  root = 'http://dev.www.phone580.com'
  walletRoot = 'http://dev.www.phone580.com'
  otherApiRoot = 'http://dev.www.phone580.com'
  comApiRoot = 'http://dev.www.phone580.com'
  promotionRoot = 'http://dev.www.phone580.com'
  openApiRoot = 'http://dev.www.phone580.com'
  seckillApiRoot = 'http://dev.www.phone580.com'
  orderApiRoot = 'http://dev.www.phone580.com'
  pointRoot = 'http://dev.payapi.phone580.com:8001'
} else if (!isLan) {
  root = 'http://test.www.phone580.com:8000'
  walletRoot = 'http://test.wallet.phone580.com:8000'
  otherApiRoot = 'http://test.vipapi.phone580.com:8000'
  comApiRoot = 'http://test.www.phone580.com:8000'
  promotionRoot = 'http://test.promotionapi.phone580.com:8000'
  openApiRoot = 'http://test.openapi.phone580.com:8000'
  seckillApiRoot = 'http://test.www.phone580.com:8000'
  orderApiRoot = 'http://test.orderApi.phone580.com:8000'
  pointRoot = 'http://test.payapi.phone580.com:8001'
} else {
  root = 'https://www.phone580.com'
  walletRoot = 'https://wallet.phone580.com'
  otherApiRoot = 'https://vipapi.phone580.com'
  comApiRoot = 'https://www.phone580.com'
  promotionRoot = 'https://promotionapi.phone580.com'
  openApiRoot = 'https://openapi.phone580.com'
  seckillApiRoot = 'https://seckillapi.phone580.com'
  orderApiRoot = 'https://orderapi.phone580.com'
  pointRoot = 'https://payapi.phone580.com'
}

export const Api = {
  imgRoot: root + '/xfolder'
  // 广告接口
  , ads: root + '/openapi/fzsad/ads'
  // 导航接口
  , navTree: seckillApiRoot + '/fzsActiveApi/nav/navTree/v2'
  // 常见问题.g公告
  , msg: root + '/fbsapi/api/msg/MHfindSampMsg'
  // 查询订单列表
  , userorderlist: seckillApiRoot + '/fzs-order-api/order/api/clientuserorderlist'
  // 订单详情
  , userorderdetail: seckillApiRoot + '/fzs-order-api/order/api/clientuserorderdetail'
  // 查询订单状态
  , userorderState: seckillApiRoot + '/fzs-order-api/order/api/userorderdetail'
  // 获取订单支付方式
  , getPayMethods: seckillApiRoot + '/fzs-order-api/order/api/get-pay-methods'
  // 二次支付
  , secondPay: seckillApiRoot + '/fzs-order-api/order/api/second-pay'
  // 关闭订单
  , closeOrder: seckillApiRoot + '/fzs-order-api/order/api/close-order'
  // 删除订单
  , removeOrder: seckillApiRoot + '/fzs-order-api/order/api/remove-order'

  , behalfRecord: orderApiRoot + '/fzs-order-api/order/behalf/record' //代付订单记录 ?projectId=6#3703
  // 图形验证码
  , captcah: comApiRoot + '/fzscaptchaapi/captcah/captcah.jpg'
  // 短信验证码
  , sendsmscode: seckillApiRoot + 
    (!isLan ? '/fzsuserapi/user/sendsmscode' : '/fzsuserapi/user/limit-sendsmscode')
  // 一键登录
  , authloginV2: seckillApiRoot + 
    (!isLan ? '/fzsuserapi/api/user/authloginv2' : '/fzsuserapi/api/user/limit-authloginv2')

  , getAuthTokenByTicket: openApiRoot + '/wechat/openapi/getAuthTokenByTicket'
  , userInfo: root + '/fbsapi/api/user/userinfo'
  // 营销系统查询商品接口
  , skuList: seckillApiRoot + '/fmapi/api/action/query-scheme-sku-list'
  // 预估佣金批量查询
  , commission: promotionRoot + '/fzscommissionapi/api/account/batch-estimate-commission'
  // 获取授权优惠券列表（卡券中心）
  , getAuthCoupon: walletRoot + '/fzswalletapi/coupon/getcoupondatas/web/getauthcoupon'
  // 登记用户开奖资格
  , collectUserAction: seckillApiRoot + '/fmapi/api/action/collect-user-action'
  // 领取用户奖品
  , receiveUserPrize: seckillApiRoot + '/fmapi/api/cptc/user-receive-cx-cptc'
  // 卡包接口
  , walletApi: walletRoot + '/openapi/fzsad/ads',
  // 根据父目录获取子目录信息
  category: seckillApiRoot + '/fzs-product-api/product/api/category',
  // 根据目录Id或者目录编码获取该目录下所有商品
  category_product: seckillApiRoot + '/fzs-product-api/product/api/category/product',
  // 根据客户端获取商品列表
  productlist: seckillApiRoot + '/fzs-product-api/product/api/productlist',
  // 根据标签获取对应的商品列表
  tag_product: seckillApiRoot + '/fzs-product-api/product/api/tag/product',
  // 获取商品的单品列表
  productsku: seckillApiRoot + '/fzs-product-api/product/api/productsku',
  // 获取商品详情
  productdetail: seckillApiRoot + '/fzs-product-api/product/api/productdetail',
  // 下单接口
  placeorder: seckillApiRoot + '/fzs-order-api/order/api/placeorder-v2',

  // 优惠券实例码激活
  checkCoupon: walletRoot + '/fzswalletapi/coupon/getcoupondatas/web/checkcouponexamplenew',
  // 查询商品成长值金币值
  getValue: otherApiRoot + '/vip/front/getvalue',
  // 获取用户优惠券
  getCouponWithUserInfo: walletRoot + '/fzswalletapi/coupon/getcoupondatas/web/getMyCoupon',
  // 根据商品获取优惠券
  getCouponWithProduct: walletRoot + '/fzswalletapi/coupon/getcoupondatas/web/getvalidcouponnew',
  // 获取商品类型下可用的优惠券(可领取和已领取)-token(新增)
  getReceiveuseCouponNew: walletRoot + '/fzswalletapi/coupon/getcoupondatas/web/getreceiveusecouponnew',

  // 获取商品可领取优惠券及已领取
  getProductAvaliableCoupon: walletRoot + '/fzswalletapi/coupon/getcoupondatas/web/getreceiveusecouponwx',
  // 领取优惠券
  receivecouponwx: walletRoot + '/fzswalletapi/coupon/opercoupon/web/receivecouponwx',
  // 领取优惠券 -- authken
  receivecoupon: walletRoot + '/fzswalletapi/coupon/opercoupon/web/receivecoupon',
  // 下单前获取可用的优惠券
  getvalidcoupon: walletRoot + '/fzswalletapi/coupon/getcoupondatas/web/getvalidcouponwx',
  // 活动接口
  activityApi: seckillApiRoot + '/fzsActiveApi/clientActivity/listWithUserState',
  // 登记活动业务量
  registerActivity: seckillApiRoot + '/fzsActiveApi/clientActivity/logTscPay/v2',
  // 获取用户地址列表
  addressList: comApiRoot + '/fzsuserinfoapi/address/list',
  // 获取用户默认地址
  addressDefautl: comApiRoot + '/fzsuserinfoapi/address/getdefault',
  // 增加用户地址
  addAddress: comApiRoot + '/fzsuserinfoapi/address/add',
  // 设置为默认地址
  setDefault: comApiRoot + '/fzsuserinfoapi/address/setdefault',
  // 修改地址
  modifyAddress: comApiRoot + '/fzsuserinfoapi/address/modify',
  // 删除地址
  deleteAddress: comApiRoot + '/fzsuserinfoapi/address/del',
  // 查询快递信息
  searchExpressInfo: root + '/fzs-outgateway-api/gateway/api/proxy',

  // 查询邀请码
  queryCode: promotionRoot + '/fzscommissionapi/api/account/query-invitatoin-code',

  // 1.3.查询银行卡信息
  queryBankCard: promotionRoot + '/fzscommissionapi/api/account/query-bank-card',
  // 获取建行钱包支付短信验证码
  sendCbcPaySmsCode: orderApiRoot + '/paymentsapi/trade/getccbpayCode',
  // 判断是否是plus会员
  judgePlus: otherApiRoot + '/vip/plus/getinfo',
  // 商品详情--用户点击”立即购买”按钮 埋点
  buyBeforePoint: pointRoot + '/buriedpoint/digitalwallet/buybefore',
  // 商品详情--用户点击”立即购买”按钮后H5自动跳转钱包首页前 埋点
  jumpHomeBeforePoint: pointRoot + '/buriedpoint/digitalwallet/jumphomebefore',
  errorInfo: pointRoot + '/buriedpoint/digitalwallet/errorreport',
  detailLoadComplete: pointRoot + '/buriedpoint/digitalwallet/detailloadcomplete',
  sycnUserInfo: seckillApiRoot + '/fzsuserapi/api/int/sycnuserinfo' // 刷新token

}
